<script>
  import appConfig from '../appConfig_adaptation_measures.js';
  
  // the <PersistentDisclaimer> component:
  // - text box on the Adaptation Measures single and comparison views

  export let persistentDisclaimerContainer;
  export let persistentDisclaimerContainerCSS;

</script>

<div 
  class="persistent-disclaimer-container"  
  style="display: {persistentDisclaimerContainerCSS}; margin-left: 10px; box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.8)" 
  id="adaptation-measures-widget-container"
  bind:this={persistentDisclaimerContainer}
>
  <div class="persistent-disclaimer-container-text" >
    {appConfig.persistentDisclaimerText}
  </div>
</div>

<style>
  .persistent-disclaimer-container-text {
    background-color: rgb(255, 255, 255);
    color: #323232;
    padding: 5px;
    width: 350px;
    /* margin-left: 1em; */
    border: black;
    border-width: thin;
    border-style: solid;
  }

</style>
